// extracted by mini-css-extract-plugin
module.exports = {"icon":"Alerts_icon__25rEG"};